
define('ldsh!modules/start/products/headers/active/template', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<div id="products-list-title">\n    <div class="row hidden-xs hidden-sm">\n        ';
 if (isAdm) { ;
__p += '\n        <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6 text-center">\n        ';
 }  else { ;
__p += '\n        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 text-center">\n        ';
 } ;
__p += '\n            <h3 class="i18n product-info-header" data-i18n="[html]PUBLIC.PRODUCTS.DASHBOARD.TITLES.LAST_30_INFO">Información de tus últimos 30 días</h3>\n        </div>\n\n        ';
 if (isAdm) { ;
__p += '\n        <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6 text-center">\n            <h3 class="i18n product-info-header" data-i18n="PUBLIC.PRODUCTS.DASHBOARD.TITLES.COUNT_STATE" style="margin-left: 0px;">Estado de tu cuenta</h2>\n        </div>\n        ';
 } ;
__p += '\n    </div>\n\n    <div class="row visible-xs-block visible-sm-block">\n        <div class="col-xs-12 text-center" style="padding-top: 10px;">\n            <h3 class="products-small-header i18n" data-i18n="PUBLIC.PRODUCTS.DASHBOARD.TITLES.MY_PRODUCTS" style="font-size: 22px;">Mis productos</h3>\n        </div>\n    </div>\n</div>\n';

}
return __p
};});

